import axios from 'axios';
import { request } from 'http';

interface farmaciasFiltros {
    texto: string | null;
    localidad: string | null;
    provincia: string | null;
};

async function ObtenerFarmaciasSancor( prmFiltro: farmaciasFiltros) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/sancor_obtener_farmacias";

    const requestData = {
        "usuario": "mpatti",
        "clave": "all2GetHer_!",
        "filtro": {
            "texto": "",
            "localidad": "",
            "provincia": ""
        }
    };

    if (prmFiltro.texto && prmFiltro.texto.trim().length >= 3) {
        requestData.filtro['texto'] = prmFiltro.texto.trim();
    }

    if (prmFiltro.localidad && prmFiltro.localidad.trim().length >= 3) {
        requestData.filtro['localidad'] = prmFiltro.localidad.trim();
    }

    if (prmFiltro.provincia && prmFiltro.provincia.trim().length >= 3) {
        requestData.filtro['provincia'] = prmFiltro.provincia.trim();
    }

    try {

        const response = await axios.post(url, requestData);
        return response.data;

    } catch (error) {
 
        return error;
    }
};

export default ObtenerFarmaciasSancor;